import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/ai-docs',
    component: ComponentCreator('/ai-docs', '8c2'),
    exact: true
  },
  {
    path: '/download',
    component: ComponentCreator('/download', 'b81'),
    exact: true
  },
  {
    path: '/download/headless',
    component: ComponentCreator('/download/headless', 'ad8'),
    exact: true
  },
  {
    path: '/legal/agent-license',
    component: ComponentCreator('/legal/agent-license', 'c7f'),
    exact: true
  },
  {
    path: '/legal/agent-privacy',
    component: ComponentCreator('/legal/agent-privacy', '68c'),
    exact: true
  },
  {
    path: '/legal/privacy-policy',
    component: ComponentCreator('/legal/privacy-policy', '4fe'),
    exact: true
  },
  {
    path: '/legal/user-agreement',
    component: ComponentCreator('/legal/user-agreement', '820'),
    exact: true
  },
  {
    path: '/search',
    component: ComponentCreator('/search', '822'),
    exact: true
  },
  {
    path: '/web',
    component: ComponentCreator('/web', '480'),
    exact: true
  },
  {
    path: '/docs',
    component: ComponentCreator('/docs', '381'),
    routes: [
      {
        path: '/docs',
        component: ComponentCreator('/docs', 'ca1'),
        routes: [
          {
            path: '/docs/tags',
            component: ComponentCreator('/docs/tags', 'fce'),
            exact: true
          },
          {
            path: '/docs/tags/access-control',
            component: ComponentCreator('/docs/tags/access-control', '7c2'),
            exact: true
          },
          {
            path: '/docs/tags/basic-features',
            component: ComponentCreator('/docs/tags/basic-features', 'cc1'),
            exact: true
          },
          {
            path: '/docs/tags/bookmarks',
            component: ComponentCreator('/docs/tags/bookmarks', 'a82'),
            exact: true
          },
          {
            path: '/docs/tags/cross-network',
            component: ComponentCreator('/docs/tags/cross-network', '935'),
            exact: true
          },
          {
            path: '/docs/tags/device-management',
            component: ComponentCreator('/docs/tags/device-management', '9a9'),
            exact: true
          },
          {
            path: '/docs/tags/favorites',
            component: ComponentCreator('/docs/tags/favorites', '3c0'),
            exact: true
          },
          {
            path: '/docs/tags/file-filtering',
            component: ComponentCreator('/docs/tags/file-filtering', '8c0'),
            exact: true
          },
          {
            path: '/docs/tags/file-sharing',
            component: ComponentCreator('/docs/tags/file-sharing', '956'),
            exact: true
          },
          {
            path: '/docs/tags/file-tasks',
            component: ComponentCreator('/docs/tags/file-tasks', '1ad'),
            exact: true
          },
          {
            path: '/docs/tags/ftp',
            component: ComponentCreator('/docs/tags/ftp', '1eb'),
            exact: true
          },
          {
            path: '/docs/tags/link-sharing',
            component: ComponentCreator('/docs/tags/link-sharing', 'be3'),
            exact: true
          },
          {
            path: '/docs/tags/mcp',
            component: ComponentCreator('/docs/tags/mcp', '615'),
            exact: true
          },
          {
            path: '/docs/tags/navigation',
            component: ComponentCreator('/docs/tags/navigation', 'ef9'),
            exact: true
          },
          {
            path: '/docs/tags/network-management',
            component: ComponentCreator('/docs/tags/network-management', '793'),
            exact: true
          },
          {
            path: '/docs/tags/notifications',
            component: ComponentCreator('/docs/tags/notifications', 'c99'),
            exact: true
          },
          {
            path: '/docs/tags/recent-items',
            component: ComponentCreator('/docs/tags/recent-items', 'e98'),
            exact: true
          },
          {
            path: '/docs/tags/s3',
            component: ComponentCreator('/docs/tags/s3', 'abe'),
            exact: true
          },
          {
            path: '/docs/tags/sftp',
            component: ComponentCreator('/docs/tags/sftp', '718'),
            exact: true
          },
          {
            path: '/docs/tags/smb',
            component: ComponentCreator('/docs/tags/smb', 'a3f'),
            exact: true
          },
          {
            path: '/docs/tags/sync-management',
            component: ComponentCreator('/docs/tags/sync-management', 'daf'),
            exact: true
          },
          {
            path: '/docs/tags/webdav',
            component: ComponentCreator('/docs/tags/webdav', '233'),
            exact: true
          },
          {
            path: '/docs',
            component: ComponentCreator('/docs', 'd9a'),
            routes: [
              {
                path: '/docs/category/教程---基础',
                component: ComponentCreator('/docs/category/教程---基础', '086'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/category/教程---进阶',
                component: ComponentCreator('/docs/category/教程---进阶', '969'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/intro',
                component: ComponentCreator('/docs/intro', 'c5d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-basics/app_drawer/',
                component: ComponentCreator('/docs/tutorial-basics/app_drawer/', '018'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-basics/bookmark/',
                component: ComponentCreator('/docs/tutorial-basics/bookmark/', '04e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-basics/favorite/',
                component: ComponentCreator('/docs/tutorial-basics/favorite/', '40c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-basics/file/',
                component: ComponentCreator('/docs/tutorial-basics/file/', '4a2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-basics/filter/',
                component: ComponentCreator('/docs/tutorial-basics/filter/', 'f04'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-basics/filter/filter_manager_child/',
                component: ComponentCreator('/docs/tutorial-basics/filter/filter_manager_child/', '68a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-basics/filter/filter_manager/',
                component: ComponentCreator('/docs/tutorial-basics/filter/filter_manager/', '333'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-basics/home/',
                component: ComponentCreator('/docs/tutorial-basics/home/', '159'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-basics/notification/',
                component: ComponentCreator('/docs/tutorial-basics/notification/', '34b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-basics/recent/',
                component: ComponentCreator('/docs/tutorial-basics/recent/', 'aff'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-basics/task/',
                component: ComponentCreator('/docs/tutorial-basics/task/', 'fd7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-basics/toolbox/',
                component: ComponentCreator('/docs/tutorial-basics/toolbox/', '75d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/device/',
                component: ComponentCreator('/docs/tutorial-extras/device/', 'ef3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/device/device_manage/',
                component: ComponentCreator('/docs/tutorial-extras/device/device_manage/', '6b9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/device/device_permission/',
                component: ComponentCreator('/docs/tutorial-extras/device/device_permission/', '9ab'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/device/device_role/',
                component: ComponentCreator('/docs/tutorial-extras/device/device_role/', '9ef'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/mcp/',
                component: ComponentCreator('/docs/tutorial-extras/mcp/', '475'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/mcp/third-party-access/claude/',
                component: ComponentCreator('/docs/tutorial-extras/mcp/third-party-access/claude/', '8e4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/mcp/third-party-access/codex/',
                component: ComponentCreator('/docs/tutorial-extras/mcp/third-party-access/codex/', 'f66'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/mcp/tools',
                component: ComponentCreator('/docs/tutorial-extras/mcp/tools', '4c7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/network/',
                component: ComponentCreator('/docs/tutorial-extras/network/', '32a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/network/FTP/',
                component: ComponentCreator('/docs/tutorial-extras/network/FTP/', 'b71'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/network/LinkShare/',
                component: ComponentCreator('/docs/tutorial-extras/network/LinkShare/', 'e09'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/network/S3/',
                component: ComponentCreator('/docs/tutorial-extras/network/S3/', 'c76'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/network/SFTP/',
                component: ComponentCreator('/docs/tutorial-extras/network/SFTP/', '121'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/network/SMB/',
                component: ComponentCreator('/docs/tutorial-extras/network/SMB/', '767'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/network/WebDav/',
                component: ComponentCreator('/docs/tutorial-extras/network/WebDav/', 'c78'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/share/',
                component: ComponentCreator('/docs/tutorial-extras/share/', '6e6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/share/device/',
                component: ComponentCreator('/docs/tutorial-extras/share/device/', 'd01'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/share/file/',
                component: ComponentCreator('/docs/tutorial-extras/share/file/', '10d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/share/http/',
                component: ComponentCreator('/docs/tutorial-extras/share/http/', '284'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/sync/',
                component: ComponentCreator('/docs/tutorial-extras/sync/', 'a4b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorial-extras/webrtc/',
                component: ComponentCreator('/docs/tutorial-extras/webrtc/', '79c'),
                exact: true,
                sidebar: "tutorialSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: ComponentCreator('/', 'e5f'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
